

































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Popup } from '@lx-frontend/cvux'

@Component({
  components: {
    Popup
  }
})
export default class PlateNumberOrVinPopup extends Vue {
  @Prop(Boolean) readonly isShowPopup!: boolean
  @Prop(String) readonly placeholder!: string
  @Prop(String) readonly searchVal!: string
  @Prop() valMaxLen!: number
  @Prop() queryType!: number

  searchList: any = []
  timer: any = null
  inptSearchVal = ''

  async handlePlateNumberInputOrVin() {
    if (this.inptSearchVal === '' || this.inptSearchVal.length < this.valMaxLen) {
      this.searchList = []
      return
    }
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(async () => {
      const { code, data, message } = await this.$rest.appointment.getBookingRecord({
        query_type: this.queryType, query_text: this.inptSearchVal
      })
      if (code !== 0) {
        this.showToast(message)
        return
      }
      this.searchList = data
    }, 1000)
  }

  handleConfirm() {
    this.$emit('on-confirm', this.inptSearchVal)
  }

  handleSelectPlateNumberOrVin(item: any) {
    this.$emit('on-item', item)
  }

  @Watch('isShowPopup')
  watchIsShowPopup(val: boolean) {
    if (val) this.inptSearchVal = this.searchVal
  }
}
